const Footer = () => {
  return (
    <footer>
      <p>Powered by OMDb ©{new Date().getFullYear()} Hallvard Jensen</p>
    </footer>
  );
};

export default Footer;
